import React, { FunctionComponent } from 'react'
import { useSelector } from 'hook'
import {
  Link,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
} from '@material-ui/core'
import { LANGUAGE } from 'constants/language'
import { FONTSIZE } from 'constants/fontSize'
import useStyles, { OpacityStyle } from './style'
import { Article } from 'text/article'
import { ContentTitle } from 'components/Parts'

const OpacityTableCell = OpacityStyle(TableCell)

type TableRowComponent = FunctionComponent<{ row: Array<string> }>

const MyTableCell: FunctionComponent = ({ children }) => {
  const classes = useStyles()
  const fontSizeManager = useSelector((state) => state.fontSizeManager)
  return (
    <OpacityTableCell>
      <Typography
        className={
          fontSizeManager === FONTSIZE.LARGE
            ? classes.cell_font_large
            : classes.cell_font_small
        }
      >
        {children}
      </Typography>
    </OpacityTableCell>
  )
}

const NormalTableCell: TableRowComponent = ({ row }) => {
  return (
    <TableRow>
      {row.map((cell, i) => (
        <MyTableCell key={i}>{cell}</MyTableCell>
      ))}
    </TableRow>
  )
}

const LinkTableCell: TableRowComponent = ({ row }) => {
  const classes = useStyles()
  return (
    <TableRow>
      <MyTableCell>
        <Link href={row[1]} className={classes.link_detail}>
          {row[0]}
        </Link>
      </MyTableCell>
      <MyTableCell>
        <Link href={row[1]} className={classes.link}>
          {row[1]}
        </Link>
      </MyTableCell>
    </TableRow>
  )
}

const HeadTableCell: TableRowComponent = ({ row }) => {
  if (row.length > 0) {
    return (
      <TableHead>
        <NormalTableCell row={row} key="head" />
      </TableHead>
    )
  } else {
    return <></>
  }
}

const HiddenHeadTableCell: FunctionComponent<{
  article: Article
  isJP: boolean
}> = ({ article, isJP }) => {
  if (article.headers === undefined) {
    return <></>
  } else {
    return (
      <HeadTableCell row={isJP ? article.headers.jp : article.headers.en} />
    )
  }
}

const TableContent: FunctionComponent<{
  article: Article
  name: string
  isLink?: boolean
}> = ({ article, name, isLink = false }) => {
  const classes = useStyles()
  const languageManager = useSelector((state) => state.languageManager)
  const isJP = languageManager === LANGUAGE.JP
  return (
    <Box className={classes.root}>
      <ContentTitle to={name}>
        {isJP ? article.title.jp : article.title.en}
      </ContentTitle>
      <TableContainer component={Paper} className={classes.card} elevation={6}>
        <Table className={classes.table}>
          <HiddenHeadTableCell article={article} isJP={isJP} />
          <TableBody>
            {(isJP ? article.rows.jp : article.rows.en).map((row, i) =>
              isLink ? (
                <LinkTableCell row={row} key={i} />
              ) : (
                <NormalTableCell row={row} key={i} />
              )
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  )
}

export default TableContent
